import Box from "@mui/material/Box";
import Skeleton from "../../../../../CommonComponents/Skeleton";

export const SOAActivitySkeleton = () => {
  return (
    <Box sx={{width:"110%",height:"192px",bgcolor: "white",display:"flex",flexDirection:"column",padding:"16px 24px",borderRadius:"8px"}}>
        <Skeleton animation="wave" sx={{width:"110px",height:"28px"}}/>
        <Box
            sx={{display:"flex",height:"120px",gap:"10px",marginTop:"12px"/* ,width:"543.87px" */}}
        >
            {Array.from({ length: 3 }).map((_, i) => (
                <Skeleton key={i} sx={{height:"120px",width:"174.5px"}} animation="wave" />
            ))}
        </Box>
    </Box>
  )
}
